import * as React from 'react';
import { useState } from 'react'
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import EmailIcon from '@mui/icons-material/Email';
import GreenvironmentLogo from '../../../src/Images/GreenvironmentLogo.svg'
import { postForgotPassword } from '../../Redux/actions';
import AlertDialog from '../Common/AlertDialog';
import Loader from '../Common/Loader';
import AuthHero from './AuthHero';
import { authGradientButtonSx } from '../../theme/formStyles';
import './Login.css';

const ForgotPassword = () => {

  let navigate = useNavigate();
  const dispatch = useDispatch();
  const initForm = {
      email: '',
  };
  const initErr = {};
  const [form, setForm] = useState(initForm);
  const [errors, setErrors] = useState(initErr);
  const [alertMessage, setAlertMessage] = useState(null);
  const [disableBtn, setDisableBtn] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  const handleChange = (e) => {
    const { value, name } = e.target;
    const fieldValue = Object.assign({}, form);
    const errorField = Object.assign({}, errors);
    if (errorField[name]) {
        errorField[name] = null;
        setErrors(errorField);
    }
    fieldValue[name] = value;
    setForm(fieldValue);
};

const emailValidator = (email) =>{
  const pattern = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i);
  return pattern.test(email);
}

const validateData = () => {
  let hasError = false;
  const err = Object.assign({}, errors);
  if (!emailValidator(form.email)) {
      hasError = true;
      err.email = 'Enter a valid email.';
  }
  Object.keys(form).forEach((key) => {
      if (typeof (form[key]) === 'string' && key !== 'password' && key !== 'confirm') {
          if (!form[key].match(/\w/)) {
              hasError = true;
              err[key] = 'This field is mandatory';
          }
      }
      if (!form[key]) {
          hasError = true;
          err[key] = 'This field is mandatory';
      }
  });
  if (hasError) {
      setErrors(err);
      return false;
  }
  return form;
};

const handleSubmit = (e) => {
  e.preventDefault();
   const valid = validateData();
  if (valid) {
      setShowLoader(true)
      setDisableBtn(true);
      dispatch(postForgotPassword(valid)).then((resp) => {
          setShowLoader(false)
          const res = resp && resp.data;

          if (res && res.success) {
              setAlertMessage(res.message);
          } else if (res && res.data) {
              setErrors(res.data);
          } else {
              setAlertMessage('Something went wrong. Try again...!');
          }
          setDisableBtn(false);
      });
  }
};

  return (
    <div className="gv-login-page">
      <AuthHero />

      <div className="gv-login-panel">
        <div className="gv-login-card">
          <div className="gv-login-card-logo">
            <img alt="Greenvironment" src={GreenvironmentLogo} />
          </div>
          <div className="gv-login-heading">Forgot password?</div>
          <div className="gv-login-subheading">Enter your email and we&rsquo;ll send you a reset link</div>

          <form noValidate onSubmit={handleSubmit}>
            <div className="gv-login-field-row">
              <label className="gv-login-label" htmlFor="email">Email</label>
            </div>
            <div className="gv-login-input-wrap">
              <span className="gv-login-input-ico"><EmailIcon fontSize="small" /></span>
              <input
                id="email"
                className="gv-login-input"
                placeholder="Enter your email"
                name="email"
                required
                autoFocus
                value={form.email.toLowerCase()}
                onChange={handleChange}
              />
            </div>
            {errors.email && <div className="gv-login-error">{errors.email}</div>}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={authGradientButtonSx}
            >
              Send Reset Link
            </Button>
          </form>

          <div className="gv-login-footer-link">
            <Link className="gv-login-forgot-link" to="/login">Back to Login</Link>
          </div>
        </div>
      </div>

      {alertMessage
              ? (
                  <AlertDialog
                      handleClose={() => {
                          setAlertMessage(null);
                          navigate(-1);
                      }}
                      message={alertMessage}
                  />
              ) : null}
          {showLoader && <Loader open={showLoader}/>}
    </div>
  );
}

export default ForgotPassword
